import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, inject, input } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { CMSFacade } from 'ish-core/facades/cms.facade';
import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { ContentPageletView } from 'ish-core/models/content-view/content-view.model';
import { CMSComponent } from 'ish-shared/cms/models/cms-component/cms-component.model';
import { ProductsListComponent } from 'ish-shared/components/product/products-list/products-list.component';

@Component({
  selector: 'ish-cms-product-list-filter',
  templateUrl: './cms-product-list-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ProductsListComponent],
})
export class CMSProductListFilterComponent implements CMSComponent, OnChanges {
  private cmsFacade = inject(CMSFacade);
  private shoppingFacade = inject(ShoppingFacade);

  readonly pagelet = input.required<ContentPageletView>();

  productSKUs$: Observable<string[]>;

  ngOnChanges() {
    if (this.pagelet().hasParam('Filter')) {
      this.productSKUs$ = this.getProductSKUs$();
    }
  }

  private getProductSKUs$(): Observable<string[]> {
    return this.shoppingFacade.selectedCategoryId$.pipe(
      switchMap(categoryId =>
        this.cmsFacade.parameterProductListFilter$(
          categoryId,
          this.pagelet().stringParam('Filter'),
          this.pagelet().stringParam('Scope'),
          this.pagelet().numberParam('MaxNumberOfProducts')
        )
      )
    );
  }
}
